module.exports = __webpack_public_path__ + "images/illustrations/illustration-highwire-c7cf1e01916bcf830aba24688a851cb5.webp";